import { createContext } from 'react';

const CategoryStoresContext = createContext({
  storesLookup: {},
  productStoresMap: {},
  productDistancesMap: {},
  loading: false,
});

export default CategoryStoresContext;
